import { render, staticRenderFns } from "./DashBoardNav.vue?vue&type=template&id=651280ab&"
import script from "./DashBoardNav.vue?vue&type=script&lang=js&"
export * from "./DashBoardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disks/apps/api/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('651280ab', component.options)
    } else {
      api.reload('651280ab', component.options)
    }
    module.hot.accept("./DashBoardNav.vue?vue&type=template&id=651280ab&", function () {
      api.rerender('651280ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DashBoardNav.vue"
export default component.exports